import LoggedUserManager from '@/services/LoggedUserManager';
import { vxm } from '@/store/store.vuex';
import { DepartmentArray } from './arrayModels/DepartmentArray';
import { DepartmentSettings } from './DepartmentSettings';
export class Department {
    id;
    name;
    createdAt;
    settings;
    member;
    disableStatus;
    issuesSummary;
    application;
    isFeatureExceeded;
    hasActiveService;
    acceptanceProtocolStatus;
    //TODO: experimental, not implemented on backend
    organization = null;
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return new DepartmentArray(data.map((et) => Department.define(et)));
        }
        else if (data != null) {
            return Department.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let departmentData = data;
        if (data.Department) {
            departmentData = data.Department;
        }
        let department = new Department();
        department.id = departmentData.Id;
        department.name = departmentData.Name;
        department.createdAt = departmentData.CreatedAt;
        department.isFeatureExceeded = departmentData.IsFeatureExceeded;
        department.hasActiveService = departmentData.HasActiveService;
        department.acceptanceProtocolStatus = departmentData.AcceptanceProtocolStatus;
        department.disableStatus = {
            isDisabled: departmentData.IsDisabled,
            disabledAt: departmentData.DisabledAt,
            disabledReason: departmentData.DisabledReason
        };
        department.settings = DepartmentSettings.fromApi(departmentData.Settings);
        if (data.Member) {
            department.member = data.Member;
        }
        if (departmentData.Issues) {
            department.issuesSummary = department.remapIssueSummary(departmentData.Issues);
        }
        if (departmentData.Application) {
            department.application = departmentData.Application;
        }
        return department;
    }
    remapIssueSummary(issues) {
        return issues.map((issue) => ({
            type: issue.Type,
            alarmLevel: issue.AlarmLevel,
            notAcknowledged: issue.NumOfNotAcknowledged,
            notResolved: issue.NumOfUnresolved
        }));
    }
    static hasPermissionToViewDepartment(departmentId) {
        if (!LoggedUserManager.isResellerAdmin())
            return true;
        else
            return !!vxm.departmentStore.departments.find((x) => x.id === departmentId);
    }
    /**
     * Check whether the department is disabled for the user, excluding admin users.
     * @returns true if department is disabled and user is not admin, otherwise false.
     */
    static isDepartmentDisabled(department) {
        return (department?.disableStatus?.isDisabled ?? false) && !LoggedUserManager.isAdmin();
    }
}
